import './MobileMenu/MobileMenue.js'
import './ShowMobileSearch/ShowMobileSearch.js'
import './RegisterMember/RegisterMember.js'
import './UpdateMember/UpdateMember.js'

import './Vendors/HeaderAnimation.js'
import './Vendors/sg-shariff.js'
import './Vendors/InitializeShariff.js'

document.querySelectorAll('.download-teaser').forEach(function(element) {
  const teaserHeading = element.querySelector('.ec-heading')
  let headingHeight

  window.addEventListener("load", function() {
    headingHeight = teaserHeading.clientHeight
    teaserHeading.style.top = (-(headingHeight)-46)+'px'
  })
})
